import React from "react";
import clsx from "clsx";
import { Form } from "react-bootstrap";

import styles from "./formField.module.scss";

const ReadOnlyInput = ({
	name,
	value,
	isLocked,
	disabled,
	isPlainText,
	...props
}) => {
	const lockedStyles = isLocked && styles.readOnlyInputLocked;
	const disablesStyles = disabled && styles.readOnlyInputDisabled;
	const plainTextStyles = isPlainText && "isPlainText";
	return (
		<Form.Control
			readOnly
			name={name}
			value={value}
			className={clsx(
				styles.readOnlyInput,
				lockedStyles,
				disablesStyles,
				plainTextStyles,
			)}
			{...props}
		/>
	);
};

export default ReadOnlyInput;
